import { Controller } from 'react-hook-form';

import ComboBox from 'ui/ComboBox';
import Field from 'ui/Field';

import { useSankeyFormContext } from '../../../../contexts/sankeyFormContext';
import { SankeyFlow } from '../../../../diagram/types';
import { useTeamContext } from '../../../../utils/team';
import { useSankeyFlowInteraction } from '../../../SankeyInteractionProvider/utils';
import { updateFlowNode, useAllNodeNames } from './utils';

type Props = {
  flow: SankeyFlow;
  field: 'source' | 'target';
  label?: string;
};

const FlowNodeAutocomplete: React.FC<Props> = ({ flow, field, label }) => {
  const { form } = useSankeyFormContext();
  const { teamSettings } = useTeamContext();
  const { handleBlur } = useSankeyFlowInteraction(flow);

  const nodeNames = useAllNodeNames();

  return (
    <Controller
      name={`flows.${flow.id}.${field}`}
      control={form.control}
      render={({ field: { value } }) => (
        <Field label={label} fontSize="xs">
          <ComboBox.Root
            creatable
            openOnFocus
            selectOnFocus
            suggestWhenEmpty
            listAllValuesOnFocus
            value={value}
            onChange={(value: string) => {
              handleBlur();
              updateFlowNode(form, flow.id, field, value, teamSettings);
            }}
          >
            <ComboBox.Input size="sm" />
            <ComboBox.Content onBlur={(ev) => ev.stopPropagation()}>
              {nodeNames.map((nodeName) => {
                return (
                  <ComboBox.Item
                    key={nodeName}
                    value={nodeName}
                    _focus={{ bg: 'gray.100' }}
                  >
                    {nodeName}
                  </ComboBox.Item>
                );
              })}
              <ComboBox.Creatable>
                {({ value }) => <span>+ {value}</span>}
              </ComboBox.Creatable>
            </ComboBox.Content>
          </ComboBox.Root>
        </Field>
      )}
    />
  );
};

export default FlowNodeAutocomplete;
